import React from 'react';


export const SidebarData = [
  {
    title: 'Crime',
    path: '/home',
    cName: 'nav-text'
  },
  {
    title: 'Current Affairs',
    path: '/Products',
    cName: 'nav-text'
  },
  {
    title: 'Politics',
    path: '/products',
    cName: 'nav-text'
  },
  {
    title: 'In Other News',
    path: '/team',
    cName: 'nav-text'
  },
  
];



export const SidebarData2 = [
  {
    title: 'Telangana',
    path: '/home',
    cName: 'nav-text'
  },
  {
    title: 'Andhra Pradesh',
    path: '/Products',
    cName: 'nav-text'
  },
  {
    title: 'Tamil Nadu',
    path: '/products',
    cName: 'nav-text'
  },
  {
    title: 'Karnataka',
    path: '/team',
    cName: 'nav-text'
  },
  {
    title: 'Kerala',
    path: '/team',
    cName: 'nav-text'
  },
  
];


export const SidebarData3 = [
  {
    title: 'Australia and New Zealand',
    path: '/home',
    cName: 'nav-text'
  },
  {
    title: 'Neighbours',
    path: '/Products',
    cName: 'nav-text'
  },
  {
    title: 'Asia',
    path: '/products',
    cName: 'nav-text'
  },
  {
    title: 'Africa',
    path: '/team',
    cName: 'nav-text'
  },
  {
    title: 'America',
    path: '/team',
    cName: 'nav-text'
  },
  {
    title: 'Europe',
    path: '/team',
    cName: 'nav-text'
  },
  {
    title: 'Middle East',
    path: '/team',
    cName: 'nav-text'
  },
  
];